import React from 'react'
import { StyledTree } from './Tree.styles'

function Tree({treeImg, className}) {
  return (
    <StyledTree className={className}><img src={treeImg} alt="tree" /></StyledTree>
  )
}

export default Tree;